import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { FeedbackState } from './feedback-reducer';
import { configurationState } from './configuration-selectors';

const feedbackState = (state: AppState): FeedbackState => state.feedback;

export const isLoadingSelector = createSelector(
    [feedbackState, configurationState],
    (feedback, configuration) => feedback.loading || !configuration.user
);
